// components/deviceGroupEditModal.component.js
import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
} from '@chakra-ui/react';

const DeviceGroupEditModal = ({ isOpen, onClose, group, onSave }) => {
  const [groupName, setGroupName] = useState(group.name);

  const handleSave = () => {
    onSave(group.id, groupName);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Device Group</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            value={groupName}
            onChange={e => setGroupName(e.target.value)}
            placeholder="Enter new group name"
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose} ml={3}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeviceGroupEditModal;
